import controller_idle from "./controller-idle.svg"
import controller_press from "./controller-press.svg"
import pad_down from "./pad-down.png"
import pad_left from "./pad-left.png"
import pad_right from "./pad-right.png"
import pad_up from "./pad-up.png"

export default {
    controller_idle,
    controller_press,
    pad_down,
    pad_left,
    pad_right,
    pad_up,
}